/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Intake_Waist_HintInputs */

const en_us2_body_assessment_intake_waist_hint = /** @type {(inputs: Body_Assessment_Intake_Waist_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run the tape round your navel, snug but not tight, at the end of a normal breath out.`)
};

const pt_br2_body_assessment_intake_waist_hint = /** @type {(inputs: Body_Assessment_Intake_Waist_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe a fita na altura do umbigo, encostada mas sem apertar, no fim de uma expiração normal.`)
};

const es_419_body_assessment_intake_waist_hint = /** @type {(inputs: Body_Assessment_Intake_Waist_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasa la cinta a la altura del ombligo, pegada pero sin apretar, al final de una exhalación normal.`)
};

const pt_pt2_body_assessment_intake_waist_hint = /** @type {(inputs: Body_Assessment_Intake_Waist_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a fita à altura do umbigo, encostada mas sem apertar, no fim de uma expiração normal.`)
};

const fr_fr2_body_assessment_intake_waist_hint = /** @type {(inputs: Body_Assessment_Intake_Waist_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passe le ruban au niveau du nombril, ajusté sans serrer, à la fin d'une expiration normale.`)
};

const de_de2_body_assessment_intake_waist_hint = /** @type {(inputs: Body_Assessment_Intake_Waist_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg das Maßband auf Nabelhöhe an, anliegend, aber nicht straff, am Ende einer normalen Ausatmung.`)
};

const it_it2_body_assessment_intake_waist_hint = /** @type {(inputs: Body_Assessment_Intake_Waist_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa il metro all'altezza dell'ombelico, aderente ma senza stringere, alla fine di una normale espirazione.`)
};

/**
* | output |
* | --- |
* | "Run the tape round your navel, snug but not tight, at the end of a normal breath out." |
*
* @param {Body_Assessment_Intake_Waist_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_intake_waist_hint = /** @type {((inputs?: Body_Assessment_Intake_Waist_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Intake_Waist_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_intake_waist_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_intake_waist_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_intake_waist_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_intake_waist_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_intake_waist_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_intake_waist_hint(inputs)
	return en_us2_body_assessment_intake_waist_hint(inputs)
});
export { body_assessment_intake_waist_hint as "body-assessment.intake_waist_hint" }